import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Admin API calls
export const adminApi = {
  // Metrics
  getMetrics: () => axios.get(`${API}/admin/metrics`),
  getActivity: (limit = 50) => axios.get(`${API}/admin/activity`, { params: { limit } }),
  getPipelineQueue: () => axios.get(`${API}/admin/pipeline-queue`),

  // Organisations
  listOrgs: (params = {}) => axios.get(`${API}/admin/orgs`, { params }),
  getOrg: (orgId) => axios.get(`${API}/admin/orgs/${orgId}`),
  createOrg: (data) => axios.post(`${API}/admin/orgs`, data),
  updateOrg: (orgId, data) => axios.patch(`${API}/admin/orgs/${orgId}`, data),
  getOrgAuditLog: (orgId) => axios.get(`${API}/admin/orgs/${orgId}/audit-log`),

  // Pipeline
  triggerPipeline: (orgId) => axios.post(`${API}/admin/orgs/${orgId}/pipeline/trigger`),
  getPipelineStatus: (orgId) => axios.get(`${API}/admin/orgs/${orgId}/pipeline/status`),

  // Invites
  sendInvite: (orgId) => axios.post(`${API}/admin/orgs/${orgId}/invite`),
};

// CHRO API calls
export const chroApi = {
  // Signal Room
  getSignalRoom: () => axios.get(`${API}/chro/signal-room`),
  createShareableLink: () => axios.post(`${API}/chro/signal-room/share`),
  revokeShareableLink: (linkId) => axios.delete(`${API}/chro/signal-room/share/${linkId}`),

  // Blueprints
  listBlueprints: () => axios.get(`${API}/chro/blueprints`),
  getBlueprint: (blueprintId) => axios.get(`${API}/chro/blueprints/${blueprintId}`),
  createBlueprint: (selectedFunctions) => {
    // Build query string manually to properly repeat the parameter
    const params = new URLSearchParams();
    selectedFunctions.forEach(func => params.append('selected_functions', func));
    return axios.post(`${API}/chro/blueprints?${params.toString()}`);
  },
  moleculariseBlueprint: (blueprintId) => axios.post(`${API}/chro/blueprints/${blueprintId}/molecularise`),
  setValueDiscipline: (blueprintId, discipline) => axios.patch(`${API}/chro/blueprints/${blueprintId}/discipline`, null, {
    params: { discipline }
  }),
  downloadBlueprintPdf: (blueprintId) => axios.get(`${API}/chro/blueprints/${blueprintId}/pdf`, {
    responseType: 'blob'
  }),
  shareBlueprintLink: (blueprintId) => axios.post(`${API}/chro/blueprints/${blueprintId}/share`),
  activateStage: (blueprintId) => axios.post(`${API}/chro/blueprints/${blueprintId}/activate-stage`),

  // Searches (Stage)
  listSearches: () => axios.get(`${API}/chro/searches`),
  getSearch: (searchId) => axios.get(`${API}/chro/searches/${searchId}`),
  createSearch: (data) => axios.post(`${API}/chro/searches`, data),
  advanceSearch: (searchId, newStage) => axios.patch(`${API}/chro/searches/${searchId}/advance`, null, { params: { new_stage: newStage } }),
  refreshMarketMap: (searchId) => axios.post(`${API}/chro/searches/${searchId}/refresh-market-map`),

  // Showcase
  getShowcaseRecommendations: (blueprintId) => axios.get(`${API}/chro/showcase/${blueprintId}`),
  actionToolRecommendation: (recommendationId, action, toolId) => 
    axios.post(`${API}/chro/showcase/${recommendationId}/action`, null, {
      params: { action, tool_id: toolId }
    }),
};

// Public API calls
export const publicApi = {
  getSharedSignalRoom: (linkId) => axios.get(`${API}/shared/${linkId}`),
};

// Candidate API calls
export const candidateApi = {
  accessPortal: (searchId, pin) => axios.post(`${API}/candidate/access/${searchId}`, null, {
    params: { pin }
  }),
  getPortal: (candidateId) => axios.get(`${API}/candidate/portal/${candidateId}`),
};

export default { adminApi, chroApi, publicApi, candidateApi };
